import React from 'react';
import '../../styles/RateCard.css';

const OptionsBrandedContent = () => {
    return (
        <section className="options-branded-content-section py-5">
            <div className="container">
                <h2 className="title text-white text-capitalize mb-4" data-aos="fade-up" data-aos-delay="200">
                    Opciones de contratación<br /><span className="highlight-bg">BeHealth Branded Content</span>
                </h2>

                <div className="table-responsive" data-aos="fade-up" data-aos-delay="200">
                    <table className="table table-bordered text-center align-middle">
                        <thead className="table-success text-white">
                            <tr>
                                <th className='pt-4 pb-4'>Formato</th>
                                <th className='pt-4 pb-4'>Espacio</th>
                                <th className='pt-4 pb-4'>Descripción</th>
                                <th className='pt-4 pb-4'>Precio</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Artículos contextuales</td>
                                <td>MetaSistema</td>
                                <td>+Boost targeted</td>
                                <td className="fw-bold text-success">
                                    Consultar
                                </td>
                            </tr>
                            <tr>
                                <td>Publinota (con Video)</td>
                                <td>MetaSistema</td>
                                <td>Internal behavioral targeting</td>
                                <td className="fw-bold text-success">
                                    Consultar
                                </td>
                            </tr>
                            <tr>
                                <td>Publinota</td>
                                <td>MetaSistema</td>
                                <td>Internal behavioral targeting</td>
                                <td className="fw-bold text-success">
                                    Consultar
                                </td>
                            </tr>
                            <tr>
                                <td>Live & Podcasts</td>
                                <td>MetaSistema</td>
                                <td>+Boost targeted</td>
                                <td className="fw-bold text-success">
                                    Consultar
                                </td>
                            </tr>
                            <tr>
                                <td>Posts (Feed)</td>
                                <td>RRSS</td>
                                <td>+Boost targeted</td>
                                <td className="fw-bold text-success">
                                    Consultar
                                </td>
                            </tr>
                            <tr>
                                <td>Stories</td>
                                <td>RRSS</td>
                                <td>+Boost targeted</td>
                                <td className="fw-bold text-success">
                                    Consultar
                                </td>
                            </tr>
                            <tr>
                                <td>Micrositios</td>
                                <td>MetaSistema</td>
                                <td>Desarrollo AdHoc</td>
                                <td className="fw-bold text-success">
                                    Consultar
                                </td>
                            </tr>
                            <tr>
                                <td>Landings</td>
                                <td>MetaSistema</td>
                                <td>Desarrollo AdHoc</td>
                                <td className="fw-bold text-success">
                                    Consultar
                                </td>
                            </tr>
                            <tr>
                                <td>Email MKT</td>
                                <td>MetaSistema</td>
                                <td>First party data</td>
                                <td className="fw-bold text-success">
                                    Consultar
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    );
};

export default OptionsBrandedContent;

